<template>
  <fieldset class="rounded p-3 border mt-2 mb-3">
    <legend>Remove keyword</legend>
    <div class="form-group">
      <p>Select keywords to remove from the list</p>
    </div>
    <div class="form-group">
      <input
        style="color: white;"
        type="button"
        value="Remove"
        class="btn btn-danger"
        :disabled="Loading"
        @click="removeKeyword"
      />
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "removeKeywords",
  data() {
    return {
      Loading: false,
    };
  },
  computed: {
    getSelectedKeywords() {
      return this.$store.getters["excludedKeywords/getSelectedKeywords"];
    },
    getExcludedKeywordsData() {
      return this.$store.getters["excludedKeywords/getExcludedKeywordsData"];
    },
  },
  methods: {
    removeKeyword() {
      // checks
      if (this.getSelectedKeywords.length === 0) {
        alert("Please select the keywords that you want to delete");
        return;
      }
      let Confirm = confirm(
        "Are you sure you want to delete selected keywords?"
      );
      if (!Confirm) return;

      // api call
      this.Loading = true;
      this.$store
        .dispatch("excludedKeywords/deleteExcludedKeyword", {
          keyIds: this.getSelectedKeywords,
        })
        .then(() => {
          this.Loading = false;
          alert("Selected keyword(s) were removed from excluded keywords list");
          this.$store.commit("excludedKeywords/SET_SELECTED_KEYWORDS", []);
          this.$store.dispatch("excludedKeywords/getExcludedKeywords", {
            searchTerm: "",
            pageNumber: this.getExcludedKeywordsData.pageNumber,
            pageSize: this.getExcludedKeywordsData.pageSize,
            sortField: this.getExcludedKeywordsData.sortField,
            sortOrder: this.getExcludedKeywordsData.sortOrder,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
